import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { pathOr } from 'ramda'
import HotelSlider from './Slider/Slider'
import PopupConstructor from "../../PopupConstructor";
import {GALLERY_POPUP} from "../../PopupConstructor/constants";
import openPopup from "../../PopupConstructor/actions/popupActions";

class HotelSliderIntro extends Component {
  static propTypes = {
    sliderItems: PropTypes.arrayOf(Object),
    fancyLinks: PropTypes.arrayOf(Object),
    slidesCounts: PropTypes.arrayOf(Object),
    locationImg: PropTypes.arrayOf(Object),
    locationText: PropTypes.string,
    locationAnchor: PropTypes.string,
    openPopupAction: PropTypes.func,
    galleryItems: PropTypes.arrayOf(Object),
  }

  static defaultProps = {
    sliderItems: [],
    fancyLinks: [],
    slidesCounts: [],
    locationImg: null,
    locationText: '',
    locationAnchor: '',
    openPopupAction: () => {},
    galleryItems: [],
  }

  openFancyBox = (fancyboxIndex, gallery) => {
    document.querySelector(`[data-fancybox-index="${fancyboxIndex}"]`).click()
  }

  openGalleryPopup = () => {
    const {
      openPopupAction,
      galleryItems,
    } = this.props
    openPopupAction(GALLERY_POPUP, Object.keys(galleryItems)?.[0]);
  }

  openFancyBoxVideoAll = () => {
    document.querySelector('[data-fancybox="gallery-video"]').click()
  }

  render() {
    const {
      sliderItems,
      fancyLinks,
      slidesCounts,
      locationImg,
      locationText,
      locationAnchor,
    } = this.props

    return (
      <React.Fragment>
        <div className="new-hotel-intro">

          <div className="top-btn-holder">
            <a href={locationAnchor} className="map-point anchor-link">
              <span className="ico"><img src={locationImg && locationImg.uri} alt="" /> </span>
              <span className="txt">{locationText}</span>
            </a>
          </div>

          <div className="hotel-intro-container">
            { /* Slider */ }
            <HotelSlider results={sliderItems} openFancyBox={this.openFancyBox}  openGalleryPopup={this.openGalleryPopup} />
            <div className="bottom-btn">
              {
                slidesCounts && slidesCounts.images_count && (
                  <div className="bottom-btn__photo">
                    <a
                      onClick={this.openGalleryPopup}
                      href="javascript:void(0)"
                      >
                      {slidesCounts.images_count} <span> {slidesCounts.images_text}</span>
                    </a>
                  </div>
                )
              }

              {
                slidesCounts && slidesCounts.videos_count && (
                  <div className="bottom-btn__video">
                    <a
                      onClick={this.openFancyBoxVideoAll}
                      href="javascript:void(0)"
                      >
                      {slidesCounts.videos_count} <span>{slidesCounts.videos_text}</span>
                    </a>
                  </div>
                )
              }

            </div>

            { fancyLinks && fancyLinks.map((link, key) => (
              <a className="hide" data-fancybox-index={key} key={key} data-fancybox={link.options.attributes['data-fancybox']} href={link.url}>&nbsp;</a>
            ))
            }

          </div>
        </div>
        <PopupConstructor />
      </React.Fragment>
    )
  }
}


export default connect(
  ({
    main: {
      setting: {
        hotelSlider,
        photoPopin,
      },
    },
    browser,
  }) => ({
    sliderItems: pathOr(null, ['items'], hotelSlider),
    fancyLinks: pathOr(null, ['fancyLinks'], hotelSlider),
    slidesCounts: pathOr(null, ['slidesCounts'], hotelSlider),
    locationImg: pathOr(null, ['iconSrc'], hotelSlider),
    locationText: pathOr(null, ['iconText'], hotelSlider),
    locationAnchor: pathOr(null, ['url'], hotelSlider),
    galleryItems: pathOr(null, ['popup'], photoPopin),
    browser,
  }),
  {
    openPopupAction: openPopup
  }
)(HotelSliderIntro)
